import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

const apiUrl = process.env.REACT_APP_API_URL
const accessToken = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken')
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

// Fetch Users With Porfolio Main
export const fetchUsersWithPortfolioMain = createAsyncThunk('get/fetchData', async () => {
  try {
    const response = await axios.get(apiUrl + '/dropdown-user')
    return response.data.data
  } catch (error) {
    return error.message
  }
})

// ** Add Contribution
export const addContribution = createAsyncThunk('appUserContribution/addContribution', async (data, { getState, dispatch }) => {
  try {
    const response = await axios.post(apiUrl + '/main-contribution', data)
    dispatch(fetchContributedUsers(getState().appUserContribution?.params))
    return response.data
  } catch (error) {
    // Check if error is rejected with value
    if (error.response && error.response.status === 422) {
      // Extract error message and errors from response data
      const { message, errors } = error.response.data

      // Construct error object with message and errors
      const errorObj = { message, errors }

      // Reject the promise with the error object
      return rejectWithValue(errorObj)
    } else {
      // If there's an error other than 422, reject the promise with the error message
      return rejectWithValue(error.message || 'An error occurred')
    }
  }
})

// ** Fetch Contributed Users
export const fetchContributedUsers = createAsyncThunk('appUserContribution/fetchContribution', async (params, { rejectWithValue }) => {
  try {
    const response = await axios.get(apiUrl + '/main-contribution', params)
    return response.data
  } catch (error) {
    // return error.message
    // Check if error is rejected with value
    if (error.response && error.response.status === 422) {
      // Extract error message and errors from response data
      const { message, errors } = error.response.data

      // Construct error object with message and errors
      const errorObj = { message, errors }

      // Reject the promise with the error object
      return rejectWithValue(errorObj)
    } else {
      // If there's an error other than 422, reject the promise with the error message
      if (error.response.status === 403) {
        return rejectWithValue(error.response.status)
      }
      return rejectWithValue(error.message || 'An error occurred')
    }
  }
})


// ** Edit Contribution 
export const editContribution = createAsyncThunk('appUsers/editContribution', async (data, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await axios.put(apiUrl + `/main-contribution/${data.id}`, data)
    dispatch(fetchContributedUsers(getState().appUsers?.params))
    return response.data.data
  } catch (error) {
    // Check if error is rejected with value
    if (error.response && error.response.status === 422) {
      // Extract error message and errors from response data
      const { message, errors } = error.response.data

      // Construct error object with message and errors
      const errorObj = { message, errors }

      // Reject the promise with the error object
      return rejectWithValue(errorObj)
    } else {
      // If there's an error other than 422, reject the promise with the error message
      return rejectWithValue(error.message || 'An error occurred')
    }
  }
})

// ** Delete Contribution 
export const deleteContribution = createAsyncThunk('appUsers/deleteContribution', async (id, { getState, dispatch }) => {
  try {
    const response = await axios.delete(apiUrl + `/main-contribution/${id}`)
    dispatch(fetchContributedUsers(getState().appUsers?.params))
    return id;
  } catch (error) {
    // Check if error is rejected with value
    if (error.response && error.response.status === 500) {
      // Extract error message and errors from response data
      const { message, errors } = error.response.data

      // Construct error object with message and errors
      const errorObj = { message, errors }

      // Reject the promise with the error object
      return rejectWithValue(errorObj)
    } else {
      // If there's an error other than 422, reject the promise with the error message
      return rejectWithValue(error.message || 'An error occurred')
    }
  }
})



const saveToRedux = (state, payload) => {
  if (state?.data === payload?.data) return

  if (payload?.data) {
    state.data = payload.data
    state.total = payload.total
    state.nextPageUrl = payload.next_page_url
    state.prevPageUrl = payload.prev_page_url
  } else {
    state.message = payload
  }
}

export const appUserContributionSlice = createSlice({
  name: 'appUserContribution',
  initialState: {
    data: [], // Array to store contribution details
    message: '', // Message from API response
    nextPageUrl: null,
    prevPageUrl: null,
    total: 0,
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchContributedUsers.pending, state => {
      state.loading = true // Set loading true to show loading screen
    })

    // API response received state (SUCCESS)
    builder.addCase(fetchContributedUsers.fulfilled, (state, action) => {
      // Assuming action.payload is the response from the API
      saveToRedux(state, action.payload) // Saving contributions to redux
      state.loading = false // Set loading false to hide loading screen
    })

    // API response received state (FAILURE)
    builder.addCase(fetchContributedUsers.rejected, (state, action) => {
      state.message = action.payload?.message || 'Failed to fetch user!'
      state.loading = false // Set loading false to hide loading screen
    })

    builder.addCase(deleteContribution.pending, state => {
      state.loading = true // Set loading true to show loading screen
    })

    // API response received state (SUCCESS)
    builder.addCase(deleteContribution.fulfilled, (state, action) => {
      // Assuming action.payload is the response from the API
      state.loading = false // Set loading false to hide loading screen
      state.roles = state.appUsers?.filter(user => user.id !== action.payload)
    })

    // API response received state (FAILURE)
    builder.addCase(deleteContribution.rejected, (state, action) => {
      state.message = action.payload?.message || 'Failed to delete!'
      state.loading = false // Set loading false to hide loading screen
    })

    builder.addCase(addContribution.pending, state => {
      state.loading = true // Set loading true to show loading screen
    })

    // API response received state (SUCCESS)
    builder.addCase(addContribution.fulfilled, (state, action) => {
      // Assuming action.payload is the response from the API
      saveToRedux(state, action.payload) // Saving users to redux
      state.loading = false // Set loading false to hide loading screen
    })

    // API response received state (FAILURE)
    builder.addCase(addContribution.rejected, (state, action) => {
      state.message = action.payload?.message || 'Failed to add user!'
      state.loading = false // Set loading false to hide loading screen
    })

    builder.addCase(editContribution.pending, state => {
      state.loading = true // Set loading true to show loading screen
    })

    // API response received state (SUCCESS)
    builder.addCase(editContribution.fulfilled, (state, action) => {
      // Assuming action.payload is the response from the API
      saveToRedux(state, action.payload) // Saving users to redux
      state.loading = false // Set loading false to hide loading screen
    })

    // API response received state (FAILURE)
    builder.addCase(editContribution.rejected, (state, action) => {
      state.message = action.payload?.message || 'Failed to edit!'
      state.loading = false // Set loading false to hide loading screen
    })
  }
})

export default appUserContributionSlice.reducer
